import { useSendUserInput } from '../../../../../provider/socketContext';
import { useRemoteStore } from '../../../../../store/sceneStore';

export function RemoteRequestModal() {
	const remote = useRemoteStore;
	const sendUserInput = useSendUserInput();

	const isRemoteRequest = remote.request === 1;

	const onRemoteModeApproved = () => {
		const msg = {
			type: 'user_input',
			text: 'approval',
			value: 1,
		};
		sendUserInput(msg);
	};

	const onRemoteModeDenied = () => {
		const msg = {
			type: 'user_input',
			text: 'approval',
			value: 2,
		};
		sendUserInput(msg);
	};

	return (
		<div className={isRemoteRequest ? 'openModal modal' : 'modal'}>
			{!!isRemoteRequest && (
				<div className='modalContainer'>
					<header>
						<p
							style={{
								margin: '1vh',
								fontWeight: 400,
							}}
						>
							ᯤ A remote request is coming!
						</p>
						<p
							style={{
								margin: 0,
							}}
						>
							Continue?
						</p>
						<button
							type='button'
							className='cancel'
							onClick={onRemoteModeDenied}
						>
							&times;
						</button>
					</header>
					<main>
						<button
							type='button'
							style={{
								backgroundColor: '#007AFF',
							}}
							className='response'
							onClick={onRemoteModeApproved}
						>
							Yes
						</button>
						<button
							type='button'
							className='response'
							onClick={onRemoteModeDenied}
						>
							No
						</button>
					</main>
				</div>
			)}
		</div>
	);
}
